<div class="login-content-block">
  <form (ngSubmit) = "onSubmit()" class="login-form">
    <img src="assets/images/login_logo.png" class="login-logo">
    <input
      [(ngModel)]="id"
      class="id-input"
      name="id"
      type="text"
      placeholder="아이디를 입력해주세요"
      autocapitalize="off"
      required>
    <input
      [(ngModel)]="pwd"
      class="pwd-input"
      name="pwd"
      type="password"
      placeholder="비밀번호를 입력해주세요"
      clearinput
      required>
    <div class="chk-box">
      <mat-checkbox
        [(ngModel)]="chkId"
        value=""
        class="saveUserId"
        color="warn"
        name="saveUserId">아이디 저장</mat-checkbox>
      <mat-checkbox
        [(ngModel)]="chkAutoLogin"
        value=""
        color="warn"
        name="autoLogin">자동 로그인</mat-checkbox>
    </div>
    <button mat-button class="btn" type="submit">로그인</button>
    <p class="find-privacy" (click)="findPrivacy()">아이디/비밀번호 찾기</p>
    <p class="find-privacy" (click)="goToTerms()">개인정보 취급방침</p>
  </form>
</div>
<!-- 튜토리얼 화면 -->
<tutorial-screen></tutorial-screen>
